import { ApiDocsType } from "./IntegrationAPI";

export const apiDocs: ApiDocsType = {
    apiIntegration: {
      title: "User Management API",
      description: "Endpoints for managing users within the company",
      endpoints: [
        {
          method: "POST",
          endpoint: "/api/ApiIntegration/InviteUser",
          description: "InviteNewUser",
          details: {
            summary: "Invites a new user to the company with a specific role",
            urlParams: [],
            queryParams: [
              { name: "userEmail", type: "string", required: true, description: "Email address of the user to invite" },
              { name: "userRole", type: "long", required: true, description: "Role ID to assign to the user" },
              { name: "firstname", type: "string", required: false, description: "First name of the user" },
              { name: "lastname", type: "string", required: false, description: "Last name of the user" }
            ],
            requestBody: null,
            headers: [
              { name: "X-Api-Key", value: "YOUR_API_KEY", required: true, description: "Your company API key" }
            ],
            responses: [
              { code: "200", description: "Success", example: "User invited successfully" },
              { code: "400", description: "Bad Request", example: "This user already exists" },
              { code: "401", description: "Unauthorized", example: "API key is required" }
            ],
            example: {
              request: `curl -X POST "https://example.com/api/ApiIntegration/InviteUser?userEmail=user@example.com&userRole=2&firstname=John&lastname=Doe" \\
    -H "X-Api-Key: YOUR_API_KEY"`,
              response: `{
    "id": 123,
    "userName": "user@example.com",
    "email": "user@example.com",
    "firstName": "John",
    "lastName": "Doe",
    "companyId": 456,
    "isActive": true,
    "isApproveInvite": false
  }`
            }
          }
        },
        {
          method: "GET",
          endpoint: "/api/ApiIntegration/GetAllUser",
          description: "GetAllUser",
          details: {
            summary: "Retrieves a list of all users in the company",
            urlParams: [],
            queryParams: [],
            requestBody: null,
            headers: [
              { name: "X-Api-Key", value: "YOUR_API_KEY", required: true, description: "Your company API key" }
            ],
            responses: [
              { code: "200", description: "Success", example: "Array of user objects" },
              { code: "401", description: "Unauthorized", example: "API key is required" }
            ],
            example: {
              request: `curl -X GET "https://example.com/api/ApiIntegration/GetAllUser" \\
    -H "X-Api-Key: YOUR_API_KEY"`,
              response: `[
    {
      "id": 123,
      "userName": "user1@example.com",
      "email": "user1@example.com",
      "firstName": "John",
      "lastName": "Doe",
      "companyId": 456,
      "isActive": true,
      "isApproveInvite": true
    },
    {
      "id": 124,
      "userName": "user2@example.com",
      "email": "user2@example.com",
      "firstName": "Jane",
      "lastName": "Smith",
      "companyId": 456,
      "isActive": true,
      "isApproveInvite": true
    }
  ]`
            }
          }
        },
        {
          method: "POST",
          endpoint: "/api/ApiIntegration/EditUser/{id}",
          description: "EditUser",
          details: {
            summary: "Updates information for an existing user",
            urlParams: [
              { name: "id", type: "long", required: true, description: "ID of the user to edit" }
            ],
            queryParams: [],
            requestBody: {
              type: "object",
              properties: [
                { name: "firstName", type: "string", required: false, description: "User's first name" },
                { name: "lastName", type: "string", required: false, description: "User's last name" },
                { name: "email", type: "string", required: false, description: "User's email address" },
                { name: "isActive", type: "boolean", required: false, description: "User's active status" },
                { name: "userRoles", type: "array", required: false, description: "Array of role IDs" }
              ]
            },
            headers: [
              { name: "X-Api-Key", value: "YOUR_API_KEY", required: true, description: "Your company API key" },
              { name: "Content-Type", value: "application/json", required: true, description: "Content type" }
            ],
            responses: [
              { code: "200", description: "Success", example: "Updated user object with task status" },
              { code: "400", description: "Bad Request", example: "Invalid user data" },
              { code: "401", description: "Unauthorized", example: "API key is required" },
              { code: "404", description: "Not Found", example: "User not found" }
            ],
            example: {
              request: `curl -X POST "https://example.com/api/ApiIntegration/EditUser/123" \\
    -H "X-Api-Key: YOUR_API_KEY" \\
    -H "Content-Type: application/json" \\
    -d '{
      "firstName": "John",
      "lastName": "Smith",
      "userRoles": [2, 3]
    }'`,
              response: `{
    "companyUser": {
      "id": 123,
      "userName": "user@example.com",
      "email": "user@example.com",
      "firstName": "John",
      "lastName": "Smith",
      "companyId": 456,
      "isActive": true,
      "userRoles": [
        { "userId": 123, "roleId": 2 },
        { "userId": 123, "roleId": 3 }
      ]
    },
    "taskStatus": "Active",
    "incompleteFields": ["phoneNumber", "position"]
  }`
            }
          }
        },
        {
          method: "DELETE",
          endpoint: "/api/ApiIntegration/DeleteUser/{id}",
          description: "DeleteUser",
          details: {
            summary: "Marks a user for deletion (sets IsActive to false)",
            urlParams: [
              { name: "id", type: "long", required: true, description: "ID of the user to delete" }
            ],
            queryParams: [],
            requestBody: null,
            headers: [
              { name: "X-Api-Key", value: "YOUR_API_KEY", required: true, description: "Your company API key" }
            ],
            responses: [
              { code: "200", description: "Success", example: "User marked for deletion" },
              { code: "400", description: "Bad Request", example: "Problem with current user" },
              { code: "401", description: "Unauthorized", example: "API key is required" },
              { code: "404", description: "Not Found", example: "User not found" }
            ],
            example: {
              request: `curl -X DELETE "https://example.com/api/ApiIntegration/DeleteUser/123" \\
    -H "X-Api-Key: YOUR_API_KEY"`,
              response: `// Empty response with 200 status code`
            }
          }
        }
      ]
    },
  // Replace the existing kanbanTask object in the apiDocs with this updated version
  kanbanTask: {
    title: "Kanban Task API",
    description: "Endpoints for managing Kanban tasks and their properties",
    endpoints: [
      {
        method: "GET",
        endpoint: "/api/KanbanTask/{taskId}",
        description: "Get Task",
        details: {
          summary: "Retrieves a specific task with all its details",
          urlParams: [
            { name: "taskId", type: "long", required: true, description: "ID of the task" }
          ],
          queryParams: [],
          requestBody: null,
          headers: [
            { name: "X-Api-Key", value: "YOUR_API_KEY", required: true, description: "Your company API key" }
          ],
          responses: [
            { code: "200", description: "Success", example: "Task object with details" },
            { code: "404", description: "Not Found", example: "Task not found" },
            { code: "401", description: "Unauthorized", example: "API key is required" }
          ],
          example: {
            request: `curl -X GET "https://example.com/api/KanbanTask/123" \\
    -H "X-Api-Key: YOUR_API_KEY"`,
            response: `{
    "id": 123,
    "title": "Complete project documentation",
    "description": "Create comprehensive documentation for the API",
    "projectId": 85,
    "createdDate": "2023-05-20T10:30:00",
    "createdByUserId": 585,
    "assigneeId": 124,
    "priority": "Medium",
    "statusId": 1,
    "startDate": "2023-05-20T10:30:00",
    "dueDate": "2023-05-27T10:30:00",
    "assignee": { 
      "id": 124,
      "firstName": "Jane",
      "lastName": "Smith",
      "email": "jane.smith@example.com"
    }
  }`
          }
        }
      },
      {
        method: "POST",
        endpoint: "/api/KanbanTask",
        description: "Create Task",
        details: {
          summary: "Creates a new Kanban task",
          urlParams: [],
          queryParams: [],
          requestBody: {
            type: "object",
            properties: [
              { name: "title", type: "string", required: true, description: "Task title" },
              { name: "description", type: "string", required: false, description: "Task description" },
              { name: "projectId", type: "long", required: true, description: "Project ID" },
              { name: "assigneeId", type: "long", required: false, description: "User ID of the assignee" },
              { name: "priority", type: "string", required: false, description: "Task priority (Low, Medium, High)" },
              { name: "statusId", type: "long", required: true, description: "Status ID" },
              { name: "startDate", type: "date", required: false, description: "Task start date" },
              { name: "dueDate", type: "date", required: false, description: "Task due date" }
            ]
          },
          headers: [
            { name: "X-Api-Key", value: "YOUR_API_KEY", required: true, description: "Your company API key" },
            { name: "Content-Type", value: "application/json", required: true, description: "Content type" }
          ],
          responses: [
            { code: "201", description: "Created", example: "Created task object" },
            { code: "400", description: "Bad Request", example: "Invalid task data" },
            { code: "401", description: "Unauthorized", example: "API key is required" }
          ],
          example: {
            request: `curl -X POST "https://example.com/api/KanbanTask" \\
    -H "X-Api-Key: YOUR_API_KEY" \\
    -H "Content-Type: application/json" \\
    -d '{
      "title": "New Feature Implementation",
      "description": "Implement the new reporting feature",
      "projectId": 85,
      "assigneeId": 124,
      "priority": "High",
      "statusId": 1,
      "startDate": "2023-05-20T10:30:00",
      "dueDate": "2023-05-27T10:30:00"
    }'`,
            response: `{
    "id": 125,
    "title": "New Feature Implementation",
    "description": "Implement the new reporting feature",
    "projectId": 85,
    "createdDate": "2023-05-20T10:30:00",
    "createdByUserId": 585,
    "assigneeId": 124,
    "priority": "High",
    "statusId": 1,
    "startDate": "2023-05-20T10:30:00",
    "dueDate": "2023-05-27T10:30:00",
    "assignee": { 
      "id": 124,
      "firstName": "Jane",
      "lastName": "Smith",
      "email": "jane.smith@example.com"
    }
  }`
          }
        }
      },
      {
        method: "PUT",
        endpoint: "/api/KanbanTask/{taskId}",
        description: "Update Task",
        details: {
          summary: "Updates all properties of an existing task",
          urlParams: [
            { name: "taskId", type: "long", required: true, description: "ID of the task to update" }
          ],
          queryParams: [],
          requestBody: {
            type: "object",
            properties: [
              { name: "id", type: "long", required: true, description: "Task ID (must match URL parameter)" },
              { name: "title", type: "string", required: true, description: "Task title" },
              { name: "description", type: "string", required: false, description: "Task description" },
              { name: "projectId", type: "long", required: true, description: "Project ID" },
              { name: "assigneeId", type: "long", required: false, description: "User ID of the assignee" },
              { name: "priority", type: "string", required: false, description: "Task priority (Low, Medium, High)" },
              { name: "statusId", type: "long", required: true, description: "Status ID" },
              { name: "startDate", type: "date", required: false, description: "Task start date" },
              { name: "dueDate", type: "date", required: false, description: "Task due date" }
            ]
          },
          headers: [
            { name: "X-Api-Key", value: "YOUR_API_KEY", required: true, description: "Your company API key" },
            { name: "Content-Type", value: "application/json", required: true, description: "Content type" }
          ],
          responses: [
            { code: "200", description: "Success", example: "Updated task object" },
            { code: "400", description: "Bad Request", example: "ID mismatch or invalid task data" },
            { code: "401", description: "Unauthorized", example: "API key is required" }
          ],
          example: {
            request: `curl -X PUT "https://example.com/api/KanbanTask/125" \\
    -H "X-Api-Key: YOUR_API_KEY" \\
    -H "Content-Type: application/json" \\
    -d '{
      "id": 125,
      "title": "Updated Feature Implementation",
      "description": "Implement the new reporting feature with enhanced UI",
      "projectId": 85,
      "assigneeId": 124,
      "priority": "Medium",
      "statusId": 2,
      "startDate": "2023-05-20T10:30:00",
      "dueDate": "2023-05-30T10:30:00"
    }'`,
            response: `{
    "id": 125,
    "title": "Updated Feature Implementation",
    "description": "Implement the new reporting feature with enhanced UI",
    "projectId": 85,
    "createdDate": "2023-05-20T10:30:00",
    "createdByUserId": 585,
    "assigneeId": 124,
    "priority": "Medium",
    "statusId": 2,
    "startDate": "2023-05-20T10:30:00",
    "dueDate": "2023-05-30T10:30:00"
  }`
          }
        }
      },
      {
        method: "DELETE",
        endpoint: "/api/KanbanTask/{taskId}",
        description: "Delete Task",
        details: {
          summary: "Deletes a specific task",
          urlParams: [
            { name: "taskId", type: "long", required: true, description: "ID of the task to delete" }
          ],
          queryParams: [],
          requestBody: null,
          headers: [
            { name: "X-Api-Key", value: "YOUR_API_KEY", required: true, description: "Your company API key" }
          ],
          responses: [
            { code: "204", description: "No Content", example: "Task deleted successfully" },
            { code: "400", description: "Bad Request", example: "Error deleting task" },
            { code: "401", description: "Unauthorized", example: "API key is required" },
            { code: "404", description: "Not Found", example: "Task not found" }
          ],
          example: {
            request: `curl -X DELETE "https://example.com/api/KanbanTask/125" \\
    -H "X-Api-Key: YOUR_API_KEY"`,
            response: `// Empty response with 204 status code`
          }
        }
      },
      {
        method: "POST",
        endpoint: "/api/KanbanTask/create-intro-task",
        description: "Create Introduction Task",
        details: {
          summary: "Creates an onboarding task for a new user",
          urlParams: [],
          queryParams: [],
          requestBody: {
            type: "object",
            properties: [
              { name: "email", type: "string", required: true, description: "User's email address" },
              { name: "firstName", type: "string", required: true, description: "User's first name" },
              { name: "lastName", type: "string", required: true, description: "User's last name" }
            ]
          },
          headers: [
            { name: "X-Api-Key", value: "YOUR_API_KEY", required: true, description: "Your company API key" },
            { name: "Content-Type", value: "application/json", required: true, description: "Content type" }
          ],
          responses: [
            { code: "201", description: "Created", example: "Task created successfully" },
            { code: "400", description: "Bad Request", example: "Email, FirstName and LastName are required" },
            { code: "401", description: "Unauthorized", example: "API key is required" }
          ],
          example: {
            request: `curl -X POST "https://example.com/api/KanbanTask/create-intro-task" \\
    -H "X-Api-Key: YOUR_API_KEY" \\
    -H "Content-Type: application/json" \\
    -d '{
      "email": "user@example.com",
      "firstName": "John",
      "lastName": "Doe"
    }'`,
            response: `{
    "id": 123,
    "title": "Introduction Task for John Doe",
    "description": "...",
    "projectId": 85,
    "createdDate": "2023-05-20T10:30:00",
    "createdByUserId": 585,
    "assigneeId": 124,
    "priority": "Medium",
    "statusId": 1,
    "startDate": "2023-05-20T10:30:00",
    "dueDate": "2023-05-27T10:30:00"
  }`
          }
        }
      },
      {
        method: "GET",
        endpoint: "/api/KanbanTask/{taskId}/time",
        description: "Get Task Time Metrics",
        details: {
          summary: "Retrieves time tracking metrics for a specific task",
          urlParams: [
            { name: "taskId", type: "long", required: true, description: "ID of the task" }
          ],
          queryParams: [],
          requestBody: null,
          headers: [
            { name: "X-Api-Key", value: "YOUR_API_KEY", required: true, description: "Your company API key" }
          ],
          responses: [
            { code: "200", description: "Success", example: "Task time metrics" },
            { code: "400", description: "Bad Request", example: "Invalid task ID" },
            { code: "401", description: "Unauthorized", example: "API key is required" }
          ],
          example: {
            request: `curl -X GET "https://example.com/api/KanbanTask/123/time" \\
    -H "X-Api-Key: YOUR_API_KEY"`,
            response: `{
    "taskId": 123,
    "estimatedTime": "08:00:00",
    "totalTimeSpent": "06:45:00",
    "remainingTime": "01:15:00",
    "timeSpentPercentage": 84.375
  }`
          }
        }
      },
      {
        method: "GET",
        endpoint: "/api/KanbanTask/{taskId}/time-logs",
        description: "Get Task Time Logs",
        details: {
          summary: "Retrieves all time logging entries for a specific task",
          urlParams: [
            { name: "taskId", type: "long", required: true, description: "ID of the task" }
          ],
          queryParams: [],
          requestBody: null,
          headers: [
            { name: "X-Api-Key", value: "YOUR_API_KEY", required: true, description: "Your company API key" }
          ],
          responses: [
            { code: "200", description: "Success", example: "Array of time log objects" },
            { code: "400", description: "Bad Request", example: "Invalid task ID" },
            { code: "401", description: "Unauthorized", example: "API key is required" }
          ],
          example: {
            request: `curl -X GET "https://example.com/api/KanbanTask/123/time-logs" \\
    -H "X-Api-Key: YOUR_API_KEY"`,
            response: `[
    {
      "id": 45,
      "taskId": 123,
      "userId": 124,
      "time": "01:30:00",
      "description": "Initial implementation",
      "logDate": "2023-05-21T14:30:00"
    },
    {
      "id": 46,
      "taskId": 123,
      "userId": 124,
      "time": "02:15:00",
      "description": "Code review fixes",
      "logDate": "2023-05-22T10:45:00"
    }
  ]`
          }
        }
      },
      {
        method: "POST",
        endpoint: "/api/KanbanTask/{taskId}/estimated-time",
        description: "Update Estimated Time",
        details: {
          summary: "Updates the estimated time for a task",
          urlParams: [
            { name: "taskId", type: "long", required: true, description: "ID of the task" }
          ],
          queryParams: [],
          requestBody: {
            type: "object",
            properties: [
              { name: "estimatedTimeStr", type: "string", required: true, description: "Estimated time in format 'HH:MM:SS'" }
            ]
          },
          headers: [
            { name: "X-Api-Key", value: "YOUR_API_KEY", required: true, description: "Your company API key" },
            { name: "Content-Type", value: "application/json", required: true, description: "Content type" }
          ],
          responses: [
            { code: "200", description: "Success", example: "Updated time metrics" },
            { code: "400", description: "Bad Request", example: "Invalid time format" },
            { code: "401", description: "Unauthorized", example: "API key is required" }
          ],
          example: {
            request: `curl -X POST "https://example.com/api/KanbanTask/123/estimated-time" \\
    -H "X-Api-Key: YOUR_API_KEY" \\
    -H "Content-Type: application/json" \\
    -d '{
      "estimatedTimeStr": "10:00:00"
    }'`,
            response: `{
    "taskId": 123,
    "estimatedTime": "10:00:00",
    "totalTimeSpent": "06:45:00",
    "remainingTime": "03:15:00",
    "timeSpentPercentage": 67.5
  }`
          }
        }
      },
      {
        method: "POST",
        endpoint: "/api/KanbanTask/{taskId}/log-time",
        description: "Log Time for Task",
        details: {
          summary: "Logs time spent working on a task",
          urlParams: [
            { name: "taskId", type: "long", required: true, description: "ID of the task" }
          ],
          queryParams: [],
          requestBody: {
            type: "object",
            properties: [
              { name: "time", type: "string", required: true, description: "Time spent in format 'HH:MM:SS'" },
              { name: "description", type: "string", required: false, description: "Description of work done" },
              { name: "userId", type: "long", required: false, description: "User ID (defaults to authenticated user)" },
              { name: "endDate", type: "date", required: false, description: "End date of work (defaults to current time)" }
            ]
          },
          headers: [
            { name: "X-Api-Key", value: "YOUR_API_KEY", required: true, description: "Your company API key" },
            { name: "Content-Type", value: "application/json", required: true, description: "Content type" }
          ],
          responses: [
            { code: "200", description: "Success", example: "Time log and updated metrics" },
            { code: "400", description: "Bad Request", example: "Invalid time format" },
            { code: "401", description: "Unauthorized", example: "API key is required" }
          ],
          example: {
            request: `curl -X POST "https://example.com/api/KanbanTask/123/log-time" \\
    -H "X-Api-Key: YOUR_API_KEY" \\
    -H "Content-Type: application/json" \\
    -d '{
      "time": "01:15:00",
      "description": "Code refactoring",
      "endDate": "2023-05-23T15:30:00"
    }'`,
            response: `{
    "timeLog": {
      "id": 47,
      "taskId": 123,
      "userId": 124,
      "time": "01:15:00",
      "description": "Code refactoring",
      "logDate": "2023-05-23T15:30:00"
    },
    "metrics": {
      "taskId": 123,
      "estimatedTime": "10:00:00",
      "totalTimeSpent": "08:00:00",
      "remainingTime": "02:00:00",
      "timeSpentPercentage": 80.0
    }
  }`
          }
        }
      },
      {
        method: "GET",
        endpoint: "/api/KanbanTask/project/{projectId}",
        description: "Get Project Tasks",
        details: {
          summary: "Retrieves all tasks for a specific project",
          urlParams: [
            { name: "projectId", type: "long", required: true, description: "ID of the project" }
          ],
          queryParams: [],
          requestBody: null,
          headers: [
            { name: "X-Api-Key", value: "YOUR_API_KEY", required: true, description: "Your company API key" }
          ],
          responses: [
            { code: "200", description: "Success", example: "Array of task objects" },
            { code: "400", description: "Bad Request", example: "Invalid project ID" },
            { code: "401", description: "Unauthorized", example: "API key is required" }
          ],
          example: {
            request: `curl -X GET "https://example.com/api/KanbanTask/project/85" \\
    -H "X-Api-Key: YOUR_API_KEY"`,
            response: `[
    {
      "id": 123,
      "title": "Introduction Task for John Doe",
      "description": "...",
      "projectId": 85,
      "createdDate": "2023-05-20T10:30:00",
      "createdByUserId": 585,
      "assigneeId": 124,
      "priority": "Medium",
      "statusId": 1,
      "startDate": "2023-05-20T10:30:00",
      "dueDate": "2023-05-27T10:30:00"
    },
    {
      "id": 124,
      "title": "Another Project Task",
      "description": "...",
      "projectId": 85,
      "createdDate": "2023-05-21T11:30:00",
      "createdByUserId": 585,
      "assigneeId": 125,
      "priority": "High",
      "statusId": 2,
      "startDate": "2023-05-21T11:30:00",
      "dueDate": "2023-05-28T11:30:00"
    }
  ]`
          }
        }
      },
      {
        method: "PATCH",
        endpoint: "/api/KanbanTask/{taskId}/order",
        description: "Update Task Order",
        details: {
          summary: "Updates the order/position of a task within its status column",
          urlParams: [
            { name: "taskId", type: "long", required: true, description: "ID of the task" }
          ],
          queryParams: [],
          requestBody: {
            type: "object",
            properties: [
              { name: "newIndex", type: "integer", required: true, description: "New position index for the task" }
            ]
          },
          headers: [
            { name: "X-Api-Key", value: "YOUR_API_KEY", required: true, description: "Your company API key" },
            { name: "Content-Type", value: "application/json", required: true, description: "Content type" }
          ],
          responses: [
            { code: "200", description: "Success", example: "Updated task object" },
            { code: "400", description: "Bad Request", example: "Invalid task ID or index" },
            { code: "401", description: "Unauthorized", example: "API key is required" }
          ],
          example: {
            request: `curl -X PATCH "https://example.com/api/KanbanTask/123/order" \\
    -H "X-Api-Key: YOUR_API_KEY" \\
    -H "Content-Type: application/json" \\
    -d '{
      "newIndex": 2
    }'`,
            response: `{
    "id": 123,
    "title": "Introduction Task for John Doe",
    "description": "...",
    "projectId": 85,
    "createdDate": "2023-05-20T10:30:00",
    "createdByUserId": 585,
    "assigneeId": 124,
    "priority": "Medium",
    "statusId": 1,
    "startDate": "2023-05-20T10:30:00",
    "dueDate": "2023-05-27T10:30:00",
    "index": 2
  }`
          }
        }
      },
      {
        method: "PATCH",
        endpoint: "/api/KanbanTask/{taskId}/status",
        description: "Update Task Status",
        details: {
          summary: "Updates the status of a task (moves it between columns)",
          urlParams: [
            { name: "taskId", type: "long", required: true, description: "ID of the task" }
          ],
          queryParams: [],
          requestBody: {
            type: "object",
            properties: [
              { name: "statusId", type: "long", required: true, description: "ID of the new status" }
            ]
          },
          headers: [
            { name: "X-Api-Key", value: "YOUR_API_KEY", required: true, description: "Your company API key" },
            { name: "Content-Type", value: "application/json", required: true, description: "Content type" }
          ],
          responses: [
            { code: "200", description: "Success", example: "Updated task object" },
            { code: "400", description: "Bad Request", example: "Invalid task ID or status ID" },
            { code: "401", description: "Unauthorized", example: "API key is required" }
          ],
          example: {
            request: `curl -X PATCH "https://example.com/api/KanbanTask/123/status" \\
    -H "X-Api-Key: YOUR_API_KEY" \\
    -H "Content-Type: application/json" \\
    -d '{
      "statusId": 2
    }'`,
            response: `{
    "id": 123,
    "title": "Introduction Task for John Doe",
    "description": "...",
    "projectId": 85,
    "createdDate": "2023-05-20T10:30:00",
    "createdByUserId": 585,
    "assigneeId": 124,
    "priority": "Medium",
    "statusId": 2,
    "startDate": "2023-05-20T10:30:00",
    "dueDate": "2023-05-27T10:30:00",
    "assignee": {
      "id": 124,
      "firstName": "Jane",
      "lastName": "Smith",
      "email": "jane.smith@example.com"
    }
  }`
          }
        }
      },
      {
        method: "PATCH",
        endpoint: "/api/KanbanTask/{taskId}/assignee/{assigneeId?}",
        description: "Update Task Assignee",
        details: {
          summary: "Updates the assignee of a task or removes the assignee",
          urlParams: [
            { name: "taskId", type: "long", required: true, description: "ID of the task" },
            { name: "assigneeId", type: "long", required: false, description: "ID of the new assignee (omit to remove assignee)" }
          ],
          queryParams: [],
          requestBody: null,
          headers: [
            { name: "X-Api-Key", value: "YOUR_API_KEY", required: true, description: "Your company API key" }
          ],
          responses: [
            { code: "200", description: "Success", example: "Updated task object" },
            { code: "400", description: "Bad Request", example: "Invalid task ID or assignee ID" },
            { code: "401", description: "Unauthorized", example: "API key is required" }
          ],
          example: {
            request: `curl -X PATCH "https://example.com/api/KanbanTask/123/assignee/125" \\
    -H "X-Api-Key: YOUR_API_KEY"`,
            response: `{
    "id": 123,
    "title": "Introduction Task for John Doe",
    "description": "...",
    "projectId": 85,
    "createdDate": "2023-05-20T10:30:00",
    "createdByUserId": 585,
    "assigneeId": 125,
    "priority": "Medium",
    "statusId": 2,
    "startDate": "2023-05-20T10:30:00",
    "dueDate": "2023-05-27T10:30:00"
  }`
          }
        }
      },
      {
        method: "GET",
        endpoint: "/api/KanbanTask/{taskId}/changes",
        description: "Get Task Changes",
        details: {
          summary: "Retrieves the history of changes made to a task",
          urlParams: [
            { name: "taskId", type: "long", required: true, description: "ID of the task" }
          ],
          queryParams: [],
          requestBody: null,
          headers: [
            { name: "X-Api-Key", value: "YOUR_API_KEY", required: true, description: "Your company API key" }
          ],
          responses: [
            { code: "200", description: "Success", example: "Array of change history objects" },
            { code: "400", description: "Bad Request", example: "Invalid task ID" },
            { code: "401", description: "Unauthorized", example: "API key is required" }
          ],
          example: {
            request: `curl -X GET "https://example.com/api/KanbanTask/123/changes" \\
    -H "X-Api-Key: YOUR_API_KEY"`,
            response: `[
    {
      "id": 201,
      "taskId": 123,
      "changedByUserId": 585,
      "changeDate": "2023-05-20T10:30:00",
      "fieldName": "Status",
      "oldValue": "To Do",
      "newValue": "In Progress"
    },
    {
      "id": 202,
      "taskId": 123,
      "changedByUserId": 585,
      "changeDate": "2023-05-21T14:15:00",
      "fieldName": "Priority",
      "oldValue": "Low",
      "newValue": "Medium"
    }
  ]`
          }
        }
      },
      {
        method: "PATCH",
        endpoint: "/api/KanbanTask/{taskId}/priority",
        description: "Update Task Priority",
        details: {
          summary: "Updates the priority of a task",
          urlParams: [
            { name: "taskId", type: "long", required: true, description: "ID of the task" }
          ],
          queryParams: [],
          requestBody: {
            type: "string",
            properties: []
          },
          headers: [
            { name: "X-Api-Key", value: "YOUR_API_KEY", required: true, description: "Your company API key" },
            { name: "Content-Type", value: "application/json", required: true, description: "Content type" }
          ],
          responses: [
            { code: "200", description: "Success", example: "Updated task object" },
            { code: "400", description: "Bad Request", example: "Invalid task ID or priority" },
            { code: "401", description: "Unauthorized", example: "API key is required" }
          ],
          example: {
            request: `curl -X PATCH "https://example.com/api/KanbanTask/123/priority" \\
    -H "X-Api-Key: YOUR_API_KEY" \\
    -H "Content-Type: application/json" \\
    -d '"High"'`,
            response: `{
    "id": 123,
    "title": "Introduction Task for John Doe",
    "description": "...",
    "projectId": 85,
    "createdDate": "2023-05-20T10:30:00",
    "createdByUserId": 585,
    "assigneeId": 125,
    "priority": "High",
    "statusId": 2,
    "startDate": "2023-05-20T10:30:00",
    "dueDate": "2023-05-27T10:30:00"
  }`
          }
        }
      },
      {
        method: "GET",
        endpoint: "/api/KanbanTask/{taskId}/comments",
        description: "Get Task Comments",
        details: {
          summary: "Retrieves all comments for a specific task",
          urlParams: [
            { name: "taskId", type: "long", required: true, description: "ID of the task" }
          ],
          queryParams: [],
          requestBody: null,
          headers: [
            { name: "X-Api-Key", value: "YOUR_API_KEY", required: true, description: "Your company API key" }
          ],
          responses: [
            { code: "200", description: "Success", example: "Array of comment objects" },
            { code: "400", description: "Bad Request", example: "Invalid task ID" },
            { code: "401", description: "Unauthorized", example: "API key is required" }
          ],
          example: {
            request: `curl -X GET "https://example.com/api/KanbanTask/123/comments" \\
    -H "X-Api-Key: YOUR_API_KEY"`,
            response: `[
    {
      "id": 301,
      "taskId": 123,
      "userId": 585,
      "comment": "Initial review completed",
      "createdDate": "2023-05-21T09:45:00"
    },
    {
      "id": 302,
      "taskId": 123,
      "userId": 124,
      "comment": "Working on feedback items",
      "createdDate": "2023-05-21T14:30:00"
    }
  ]`
          }
        }
      },
      {
        method: "POST",
        endpoint: "/api/KanbanTask/{taskId}/comments",
        description: "Create Comment",
        details: {
          summary: "Adds a new comment to a task",
          urlParams: [
            { name: "taskId", type: "long", required: true, description: "ID of the task" }
          ],
          queryParams: [],
          requestBody: {
            type: "object",
            properties: [
              { name: "userId", type: "long", required: true, description: "ID of the user making the comment" },
              { name: "comment", type: "string", required: true, description: "Comment text" }
            ]
          },
          headers: [
            { name: "X-Api-Key", value: "YOUR_API_KEY", required: true, description: "Your company API key" },
            { name: "Content-Type", value: "application/json", required: true, description: "Content type" }
          ],
          responses: [
            { code: "200", description: "Success", example: "Created comment object" },
            { code: "400", description: "Bad Request", example: "Invalid task ID or comment data" },
            { code: "401", description: "Unauthorized", example: "API key is required" }
          ],
          example: {
            request: `curl -X POST "https://example.com/api/KanbanTask/123/comments" \\
    -H "X-Api-Key: YOUR_API_KEY" \\
    -H "Content-Type: application/json" \\
    -d '{
      "userId": 124,
      "comment": "Feature implementation completed"
    }'`,
            response: `{
    "id": 303,
    "taskId": 123,
    "userId": 124,
    "comment": "Feature implementation completed",
    "createdDate": "2023-05-23T16:45:00"
  }`
          }
        }
      },
      {
        method: "PUT",
        endpoint: "/api/KanbanTask/comments/{commentId}",
        description: "Update Comment",
        details: {
          summary: "Updates an existing comment",
          urlParams: [
            { name: "commentId", type: "long", required: true, description: "ID of the comment to update" }
          ],
          queryParams: [],
          requestBody: {
            type: "object",
            properties: [
              { name: "id", type: "long", required: true, description: "Comment ID (must match URL parameter)" },
              { name: "taskId", type: "long", required: true, description: "Task ID" },
              { name: "userId", type: "long", required: true, description: "User ID" },
              { name: "comment", type: "string", required: true, description: "Updated comment text" }
            ]
          },
          headers: [
            { name: "X-Api-Key", value: "YOUR_API_KEY", required: true, description: "Your company API key" },
            { name: "Content-Type", value: "application/json", required: true, description: "Content type" }
          ],
          responses: [
            { code: "200", description: "Success", example: "Updated comment object" },
            { code: "400", description: "Bad Request", example: "ID mismatch or invalid comment data" },
            { code: "401", description: "Unauthorized", example: "API key is required" }
          ],
          example: {
            request: `curl -X PUT "https://example.com/api/KanbanTask/comments/303" \\
    -H "X-Api-Key: YOUR_API_KEY" \\
    -H "Content-Type: application/json" \\
    -d '{
      "id": 303,
      "taskId": 123,
      "userId": 124,
      "comment": "Feature implementation completed and tested"
    }'`,
            response: `{
    "id": 303,
    "taskId": 123,
    "userId": 124,
    "comment": "Feature implementation completed and tested",
    "createdDate": "2023-05-23T16:45:00",
    "updatedDate": "2023-05-23T17:30:00"
  }`
          }
        }
      }
    ]
  },
  kanbanTaskStatus: {
    title: "Task Status API",
    description: "Endpoints for managing Kanban task statuses",
    endpoints: [
      {
        method: "GET",
        endpoint: "/api/KanbanTaskStatusApi/project/{projectId}",
        description: "Get Project Statuses",
        details: {
          summary: "Retrieves all status columns for a specific project",
          urlParams: [
            { name: "projectId", type: "long", required: true, description: "ID of the project" }
          ],
          queryParams: [],
          requestBody: null,
          headers: [
            { name: "X-Api-Key", value: "YOUR_API_KEY", required: true, description: "Your company API key" }
          ],
          responses: [
            { code: "200", description: "Success", example: "Array of status objects" },
            { code: "400", description: "Bad Request", example: "Invalid project ID" },
            { code: "401", description: "Unauthorized", example: "API key is required" }
          ],
          example: {
            request: `curl -X GET "https://example.com/api/KanbanTaskStatusApi/project/85" \\
    -H "X-Api-Key: YOUR_API_KEY"`,
            response: `[
    {
      "id": 1,
      "name": "To Do",
      "index": 0,
      "projectId": 85
    },
    {
      "id": 2,
      "name": "In Progress",
      "index": 1,
      "projectId": 85
    },
    {
      "id": 3,
      "name": "Done",
      "index": 2,
      "projectId": 85
    }
  ]`
          }
        }
      },
      {
        method: "GET",
        endpoint: "/api/KanbanTaskStatusApi/{statusId}",
        description: "Get Status",
        details: {
          summary: "Retrieves a specific status column by ID",
          urlParams: [
            { name: "statusId", type: "long", required: true, description: "ID of the status" }
          ],
          queryParams: [],
          requestBody: null,
          headers: [
            { name: "X-Api-Key", value: "YOUR_API_KEY", required: true, description: "Your company API key" }
          ],
          responses: [
            { code: "200", description: "Success", example: "Status object" },
            { code: "404", description: "Not Found", example: "Status not found" },
            { code: "401", description: "Unauthorized", example: "API key is required" }
          ],
          example: {
            request: `curl -X GET "https://example.com/api/KanbanTaskStatusApi/1" \\
    -H "X-Api-Key: YOUR_API_KEY"`,
            response: `{
    "id": 1,
    "name": "To Do",
    "index": 0,
    "projectId": 85
  }`
          }
        }
      },
      {
        method: "POST",
        endpoint: "/api/KanbanTaskStatusApi",
        description: "Create Status",
        details: {
          summary: "Creates a new status column for a project",
          urlParams: [],
          queryParams: [],
          requestBody: {
            type: "object",
            properties: [
              { name: "name", type: "string", required: true, description: "Status name" },
              { name: "index", type: "integer", required: true, description: "Sort order index" },
              { name: "projectId", type: "long", required: true, description: "Project ID" }
            ]
          },
          headers: [
            { name: "X-Api-Key", value: "YOUR_API_KEY", required: true, description: "Your company API key" },
            { name: "Content-Type", value: "application/json", required: true, description: "Content type" }
          ],
          responses: [
            { code: "201", description: "Created", example: "Status created successfully" },
            { code: "400", description: "Bad Request", example: "Invalid status data" },
            { code: "401", description: "Unauthorized", example: "API key is required" }
          ],
          example: {
            request: `curl -X POST "https://example.com/api/KanbanTaskStatusApi" \\
    -H "X-Api-Key: YOUR_API_KEY" \\
    -H "Content-Type: application/json" \\
    -d '{
      "name": "In Review",
      "index": 2,
      "projectId": 85
    }'`,
            response: `{
    "id": 4,
    "name": "In Review",
    "index": 2,
    "projectId": 85
  }`
          }
        }
      },
      {
        method: "PUT",
        endpoint: "/api/KanbanTaskStatusApi/{statusId}",
        description: "Update Status",
        details: {
          summary: "Updates an existing status column",
          urlParams: [
            { name: "statusId", type: "long", required: true, description: "ID of the status to update" }
          ],
          queryParams: [],
          requestBody: {
            type: "object",
            properties: [
              { name: "id", type: "long", required: true, description: "Status ID (must match URL parameter)" },
              { name: "name", type: "string", required: true, description: "Status name" },
              { name: "index", type: "integer", required: true, description: "Sort order index" },
              { name: "projectId", type: "long", required: true, description: "Project ID" }
            ]
          },
          headers: [
            { name: "X-Api-Key", value: "YOUR_API_KEY", required: true, description: "Your company API key" },
            { name: "Content-Type", value: "application/json", required: true, description: "Content type" }
          ],
          responses: [
            { code: "200", description: "Success", example: "Updated status object" },
            { code: "400", description: "Bad Request", example: "ID mismatch or invalid status data" },
            { code: "401", description: "Unauthorized", example: "API key is required" }
          ],
          example: {
            request: `curl -X PUT "https://example.com/api/KanbanTaskStatusApi/4" \\
    -H "X-Api-Key: YOUR_API_KEY" \\
    -H "Content-Type: application/json" \\
    -d '{
      "id": 4,
      "name": "Ready for QA",
      "index": 2,
      "projectId": 85
    }'`,
            response: `{
    "id": 4,
    "name": "Ready for QA",
    "index": 2,
    "projectId": 85
  }`
          }
        }
      },
      {
        method: "PATCH",
        endpoint: "/api/KanbanTaskStatusApi/{statusId}/order",
        description: "Update Status Order",
        details: {
          summary: "Changes the order/position of a status column",
          urlParams: [
            { name: "statusId", type: "long", required: true, description: "ID of the status to reorder" }
          ],
          queryParams: [],
          requestBody: {
            type: "object",
            properties: [
              { name: "newIndex", type: "integer", required: true, description: "New position index for the status" }
            ]
          },
          headers: [
            { name: "X-Api-Key", value: "YOUR_API_KEY", required: true, description: "Your company API key" },
            { name: "Content-Type", value: "application/json", required: true, description: "Content type" }
          ],
          responses: [
            { code: "200", description: "Success", example: "Reordered status object" },
            { code: "400", description: "Bad Request", example: "Invalid index or status ID" },
            { code: "401", description: "Unauthorized", example: "API key is required" }
          ],
          example: {
            request: `curl -X PATCH "https://example.com/api/KanbanTaskStatusApi/4/order" \\
    -H "X-Api-Key: YOUR_API_KEY" \\
    -H "Content-Type: application/json" \\
    -d '{
      "newIndex": 1
    }'`,
            response: `{
    "id": 4,
    "name": "Ready for QA",
    "index": 1,
    "projectId": 85
  }`
          }
        }
      },
      {
        method: "DELETE",
        endpoint: "/api/KanbanTaskStatusApi/{statusId}",
        description: "Delete Status",
        details: {
          summary: "Deletes a status column from a project",
          urlParams: [
            { name: "statusId", type: "long", required: true, description: "ID of the status to delete" }
          ],
          queryParams: [],
          requestBody: null,
          headers: [
            { name: "X-Api-Key", value: "YOUR_API_KEY", required: true, description: "Your company API key" }
          ],
          responses: [
            { code: "204", description: "No Content", example: "Status deleted successfully" },
            { code: "400", description: "Bad Request", example: "Cannot delete status with tasks" },
            { code: "401", description: "Unauthorized", example: "API key is required" }
          ],
          example: {
            request: `curl -X DELETE "https://example.com/api/KanbanTaskStatusApi/4" \\
    -H "X-Api-Key: YOUR_API_KEY"`,
            response: `// Empty response with 204 status code`
          }
        }
      }
    ]
  }
  };